import { Component, OnInit } from "@angular/core";
import { HttpService } from "../../http.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { Domain as WebsideDomain } from "../../../../../lib/Domain/Webside";
@Component({
  selector: "app-energy-storage",
  templateUrl: "./energy-storage.component.html",
  styleUrls: ["./energy-storage.component.css"]
})
export class EnergyStorageComponent implements OnInit {
  public productlists: WebsideDomain.IProduct[] = [];
  public selectedProduct: WebsideDomain.IProduct;
  public selectedtimestamp: Date = new Date();

  filterdate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };

  constructor(
    private httpService: HttpService,
    private modalService: NgbModal
  ) {}

  async ngOnInit() {
    this.productlists = await this.httpService.energystorageService.List();
    if (this.productlists.length > 0) {
      this.onSelected(this.productlists[0]);
    }
  }

  onSelected(e: WebsideDomain.IProduct) {
    this.selectedProduct = e;
  }
  OnFind(f: any) {
    this.selectedtimestamp = new Date(
      this.filterdate.year,
      this.filterdate.month - 1,
      this.filterdate.day
    );
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Page/energy-storage/energy-storage.component.ts